/**
 * RenewListingDialog
 *
 * "Keep Unit X live for N more days" — pay for another listing period, queued to start when
 * the current one ends so no days are lost (BR-94). Offered only while
 * `paidPeriod.renewable` is true. Shares its states (charging / declined / in progress /
 * card capture) with the publish dialog through ListingFeeDialog.
 */

import { ListingFeeDialog } from './ListingPublishDialog';

export function RenewListingDialog(props: Omit<React.ComponentProps<typeof ListingFeeDialog>, 'mode'>) {
  return <ListingFeeDialog mode="renew" {...props} />;
}
